export default __webpack_public_path__ + "static/media/20-world-cafe.31e92933.svg";